import dynamic from 'next/dynamic';
import { CoBrandCreditCardProps } from './CoBrandCreditCard.types';

export const CoBrandCreditCard = dynamic<CoBrandCreditCardProps>(() => import('./CoBrandCreditCard'));
// import('./CoBrandCreditCard').then(module => module.CoBrandCreditCard)
